import React from "react";
import Skeleton from "react-loading-skeleton-2";
import styled from "styled-components";

import Logo from "../../Icons/Logo";

const Index = ({ children }) => (
  <Wrapper>
    <div>
      <div className="text-center mb-4">{children || <Logo />}</div>
      <Skeleton height={16} width={144} />
    </div>
  </Wrapper>
);

/**
 * styles
 */
const Wrapper = styled.div`
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  position: fixed;
  align-items: center;
  background-color: #fff;
  justify-content: center;
`;

export default Index;
